




















































import TableProvider from '@/api/TableProvider';
import Vue from 'vue'
import SkillStubLink from './SkillStubLink.vue';
import { ISkillTreeTableRow } from '@vincentzhang96/dv-dnt-table-interfaces/src/duck';
import { IAwakeningPair, pairAwakenings } from '@/helpers/SkillTreeAwakening';

interface IData {
    autolearnSkills: number[];
    awakenings: IAwakeningPair[];

    awakensOtherSkillIds: {skillId: number, resultId: number}[];
    awakendByOtherSkillIds: {skillId: number, awakenSkillId: number}[];
    autolearnedBySkillIds: number[];

    loading: boolean;
    error: string;
}

export default Vue.extend({
    components: { SkillStubLink },
    props: {
        skillId: {
            type: Number as () => number,
        },
        pvp: {
            type: Boolean,
            default: false,
        },
        baseSkillId: {
            type: Number as () => number,
            default: 0,
        },
    },
    data(): IData {
        return {
            autolearnSkills: [],
            awakenings: [],

            awakensOtherSkillIds: [],
            awakendByOtherSkillIds: [],
            autolearnedBySkillIds: [],

            loading: false,
            error: '',
        };
    },
    watch: {
        skillId() {
            this.load();
        },
        pvp() {
            this.load();
        },
    },
    computed: {
        hasContent(): boolean {
            if (this.baseSkillId > 0) {
                return true;
            }
            return this.awakenings.length > 0
                || this.awakensOtherSkillIds.length > 0
                || this.awakendByOtherSkillIds.length > 0
                || this.autolearnSkills.length > 0
                || this.autolearnedBySkillIds.length > 0;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            if (!this.skillId) {
                return;
            }

            try {
                this.loading = true;
                this.error = '';
                this.autolearnSkills = [];
                this.awakenings = [];
                this.awakensOtherSkillIds = [];
                this.awakendByOtherSkillIds = [];
                this.autolearnedBySkillIds = [];
                // get skill tree data
                let rows = await TableProvider.getTableRowsMatching<ISkillTreeTableRow>('skilltreetable', '_SkillTableID', 'eq', this.skillId);
                if (rows.length) {
                    const r = rows[0];
                    this.autolearnSkills = (r._ChangeSkill || '').split(';').map(Number).filter((v) => !isNaN(v) && v > 0);
                    this.awakenings = pairAwakenings(
                        r._SkillConditionID as unknown as string | number,
                        r._SubSkillTableID as unknown as string | number,
                        this.pvp,
                    );
                }

                rows = await TableProvider.getTableRowsMatching<ISkillTreeTableRow>('skilltreetable', '_SkillConditionID', 'contains', this.skillId);
                if (rows.length) {
                    const out: { skillId: number, resultId: number }[] = [];
                    for (const r of rows) {
                        const pairs = pairAwakenings(
                            r._SkillConditionID as unknown as string | number,
                            r._SubSkillTableID as unknown as string | number,
                            this.pvp,
                        );
                        for (const p of pairs) {
                            if (p.conditionId === this.skillId && r._SkillTableID && p.awakenedId) {
                                out.push({ skillId: r._SkillTableID, resultId: p.awakenedId });
                            }
                        }
                    }
                    this.awakensOtherSkillIds = out;
                }

                rows = await TableProvider.getTableRowsMatching<ISkillTreeTableRow>('skilltreetable', '_SubSkillTableID', 'contains', this.skillId);
                if (rows.length) {
                    const out: { skillId: number, awakenSkillId: number }[] = [];
                    for (const r of rows) {
                        const pairs = pairAwakenings(
                            r._SkillConditionID as unknown as string | number,
                            r._SubSkillTableID as unknown as string | number,
                            this.pvp,
                        );
                        for (const p of pairs) {
                            if (p.awakenedId === this.skillId && r._SkillTableID && p.conditionId) {
                                out.push({ skillId: r._SkillTableID, awakenSkillId: p.conditionId });
                            }
                        }
                    }
                    this.awakendByOtherSkillIds = out;
                }

                rows = await TableProvider.getTableRowsMatching<ISkillTreeTableRow>('skilltreetable', '_ChangeSkill', 'in', this.skillId);
                if (rows.length) {
                    this.autolearnedBySkillIds = rows.filter((r) => r._ChangeSkill.split(';').map(Number).includes(this.skillId)).map((r) => r._SkillTableID).filter((v) => !!v);
                }
            } catch (e) {
                console.error(e);
                this.error = String(e);
            } finally {
                this.loading = false;
            }
        },
    },
})
